import type {Logger} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class LoggerDataService {
    public static serviceName = 'loggerDataService';

    private static readonly ROUTE = 'loggers';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getLoggers(): Promise<Logger[]> {
        return this.ajaxService
            .createRequest(LoggerDataService.ROUTE)
            .get();
    }

    @ngAsync()
    public async changeLevel(loggerId: string, level: string): Promise<Logger> {
        return this.ajaxService
            .createRequest(`${LoggerDataService.ROUTE}/${loggerId}`)
            .get({level});
    }
}